import { DataBean } from "../DataBean";

export class ExternalFactory extends DataBean {



    public async getExternalFactoryCatalog(idExternalFactory: any, type: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getExternalFactoryCatalog_Number_Number_String_Number_Number", [idExternalFactory, type, regexStr, page, recordsPerPage]);
    }
    public async updateExternalFactory(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ExternalFactory_updateExternalFactory_com.quickdataerp.bean.productionorders.ExternalFactory", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.productionorders.ExternalFactory"
            }
        ]);
    }
    public async deleteExternalFactory(idExternalFactory: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteExternalFactory_Number", [idExternalFactory]);
    }

}